import Select from '~/components/Select';
import { useEventTypesQuery } from '~/lib/Queries';

const EventTypeSelectDropdown = ({
    value,
    onChange,
    label,
    includeClasses,
    className,
}) => {
    const { data } = useEventTypesQuery();
    const eventTypeOptions = (data || [])
        .map(type => {
            if (includeClasses || !type.is_class) {
                return {
                    label: `${type.category?.name ? type.category?.name + ' - ' : ''}${type.name}`,
                    value: type.id,
                    isClass: type.is_class,
                    type: type,
                };
            } else {
                return null;
            }
        })
        .filter(o => !!o);

    return (
        <Select
            label={label || 'Event Type'}
            options={eventTypeOptions}
            value={value}
            onChange={onChange}
            className={className}
        />
    );
};

export default EventTypeSelectDropdown;
